const $ = require('jquery');
import { BrowserService } from './services/browser/browser.service';
import { easepick } from '@easepick/core';
import { RangePlugin } from '@easepick/range-plugin';

export const browserService = new BrowserService()
import sliderPhotoTypes from "../blocks/photo-types/photo-types";
import header from "../components/header/header";
import sliderLogo from "../blocks/logo-slider/logo-slider";
import portfolio from "../blocks/portfolio/portfolio";
import faq from "../blocks/faq/faq";
import heroBig from "../blocks/hero-big/hero-big";

window.addEventListener("DOMContentLoaded", () => {

  header();
  sliderPhotoTypes();
  sliderLogo();
  portfolio();
  faq();
  heroBig();

  const dateInput = document.getElementById('planneddate');
  if (dateInput) {
    const picker = new easepick.create({
      element: dateInput,
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.1/dist/index.css',
        'https://cdn.jsdelivr.net/npm/@easepick/range-plugin@1.2.1/dist/index.css',
      ],
      zIndex: 10,
      lang: 'pl-PL',
      format: "DD MMM YYYY",
      RangePlugin: {
        tooltip: false
      },
      plugins: [RangePlugin]
    })
  }

}, { once: true });
